import React, { Component } from 'react';
var _ = require('lodash');

export default class Quantite extends Component {
  constructor(props) {
    super(props);
    this.deleteDegat = this.deleteDegat.bind(this)
    this.addDegat = this.addDegat.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.send = _.debounce(this.send.bind(this),1000)
    this.state = {
      degat: props.degat
    };
  }
  send(){
    this.props.onChange(this.state.degat)
  }
  handleInput(e){
    let degat = this.state.degat
    degat.quantite = parseInt(e.target.value)
    this.setState({
      degat: degat
    })
    this.send()
  }
  addDegat(e){
    let degat = this.state.degat
    degat.quantite += 1
    this.setState({
      degat: degat
    })
    this.send()
  }
  deleteDegat(e){
    let degat = this.state.degat
    degat.quantite -= 1
    this.setState({
      degat: degat
    })
    this.send()
  }
  render() {
    let degat = this.state.degat
    return (
      <React.Fragment>
      <td><a onClick={this.addDegat} className="btn btn-small blue"><i className="material-icons">add</i></a></td>
      <td>
      <div className="input-field">
        <label className="active" htmlFor="number">Quantité</label>
        <input onChange={this.handleInput} type="number" value={degat.quantite}/>
      </div>

      </td>
      <td><a onClick={this.deleteDegat} className="btn btn-small red"> <i className="material-icons">delete</i></a></td>
      </React.Fragment>
    );
  }
}
